const Event = require('../Event')

class EpiappEvent extends Event {
    constructor (props) {
        super(props)

        this.type = EpiappEvent.TYPE
        this.sourceType = EpiappEvent.SOURCE_TYPE
        this.source = EpiappEvent.SOURCE

    
    }
}

EpiappEvent.TYPE = 'epi:epiapp:event'
EpiappEvent.SOURCE_TYPE = 'epiapp'
EpiappEvent.SOURCE = 'epiapp'

module.exports = EpiappEvent
